"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapCustomersWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var firestore_1 = require("firebase/firestore");
var lodash_1 = require("lodash");
var get_1 = __importDefault(require("lodash/fp/get"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var TabbedStackLayout_1 = __importDefault(require("atomicComponents/organisms/Layout/TabbedStackLayout"));
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Loadable_1 = __importDefault(require("containers/NotFoundPage/Loadable"));
var BatchLoadFilteredTable_1 = __importDefault(require("containers/TableMaker/BatchLoadFilteredTable"));
var filter_1 = require("utils/filter");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var ExportCustomersDropdown_1 = __importDefault(require("./ExportCustomersDropdown"));
var tableConf_1 = require("./tableConf");
var Table = (0, BatchLoadFilteredTable_1.default)(tableConf_1.mappingCustomersTableConf, [
    (0, filter_1.makeGroupDef)('Match Level', function (org) { var _a; return (_a = constants_1.MATCH_LEVEL_MAPPER[org.matchLevel].text) !== null && _a !== void 0 ? _a : 'Empty'; }),
    {
        group: 'Has plan',
        checkFn: function (item) { return function (f) { var _a; return (_a = item.plans) === null || _a === void 0 ? void 0 : _a.includes(f.value); }; },
        makeOptions: function (items) { return (0, lodash_1.uniq)(items.map(function (item) { return item.plans; }).filter(end2end_1.notFalsy).flat())
            .map(function (plan) { return ({ value: plan, label: plan, category: 'Has plan' }); }); },
    },
], [(0, get_1.default)('name'), (0, get_1.default)('customer.name'), (0, get_1.default)('customer.primaryContactName'), (0, get_1.default)('customer.primaryContactEmail'),
    tableConf_1.mappingCustomersTableConf.extractors.plans, function (item) { return constants_1.MATCH_LEVEL_MAPPER[item.matchLevel].text; }]);
var FILTER_MAP = {
    'for-review': function (rechOrg, landingTime) { return rechOrg.matchStatus === 'none'
        || (rechOrg.matchStatusSetOn && rechOrg.matchStatusSetOn.toDate() > landingTime); },
    confirmed: function (rechOrg) { return rechOrg.matchStatus === 'confirmed'; },
    skipped: function (rechOrg) { return rechOrg.matchStatus === 'skipped'; },
    all: function () { return true; },
};
var MapCustomers = function (_a) {
    var filterKey = _a.filterKey;
    var _b = __read(react_1.default.useState(new Date()), 2), landingTime = _b[0], setLandingTime = _b[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _c = __read((0, hooks_1.useSubmitter)('recharger_companies', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id), 2), updateRechargerCompany = _c[0], updatingRechargerCompany = _c[1];
    react_1.default.useEffect(function () { return setLandingTime(new Date()); }, [filterKey]);
    var rechCustomerIdFilter = (0, hooks_1.useQParam)('filter[customerId]');
    var filterFunction = FILTER_MAP[filterKey];
    var allRechargedOrganizations = (0, react_redux_1.useSelector)(tableConf_1.mappingCustomersTableConf.config.selector);
    var filterFn = function (items) { return items === null || items === void 0 ? void 0 : items.filter(function (rO) { return (filterFunction === null || filterFunction === void 0 ? void 0 : filterFunction(rO, landingTime)) && (!rechCustomerIdFilter || rechCustomerIdFilter === rO.customerId); }); };
    react_1.default.useEffect(function () {
        var _a;
        if (updatingRechargerCompany)
            return;
        if (rechargerCompany && !((_a = rechargerCompany.rechargeSetupSteps) === null || _a === void 0 ? void 0 : _a.includes('MAP_CUST_TO_ORGS')) && allRechargedOrganizations
            && allRechargedOrganizations.length > 0 && allRechargedOrganizations.filter(function (rO) { return rO.matchStatus === 'none'; }).length === 0) {
            updateRechargerCompany({ rechargeSetupSteps: (0, firestore_1.arrayUnion)('MAP_CUST_TO_ORGS') });
        }
    }, [allRechargedOrganizations, !!rechargerCompany]);
    if (!filterFunction) {
        return (0, jsx_runtime_1.jsx)(Loadable_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(TabbedStackLayout_1.default, __assign({ tabs: constants_1.MAP_CUSTOMERS_TABS }, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Map Customers", description: "Recharges - Map Customers" }), (0, jsx_runtime_1.jsx)(Table, { filterFunction: filterFn, width: 1085, toolbarContent: {
                    post: (0, jsx_runtime_1.jsx)(ExportCustomersDropdown_1.default, { organizations: allRechargedOrganizations || [] }),
                } })] })));
};
var MapCustomersWrapper = function () {
    var filterKey = (0, react_router_dom_1.useParams)().filterKey;
    return (0, jsx_runtime_1.jsx)(MapCustomers, { filterKey: filterKey }, filterKey);
};
exports.MapCustomersWrapper = MapCustomersWrapper;
exports.default = (0, SortHoC_1.default)(exports.MapCustomersWrapper, { key: 'name', order: 1 });
